import { useEffect, useContext } from "react";
// import { forwardRef } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import {
  EventSelector,
  EventTopCoordinates,
  UserMenu,
} from "../components";
import {
  // useLogout,
  // MenuItemLink,
  useGetIdentity,
} from "react-admin";
import { StoreContext } from "./../store/Store";
import { APIContext } from "./../store/APIStore";
import { topAppBar as classes } from './styles';

// const LogoutMenu = forwardRef<any, any>((props, ref) => {
//   // const translate = useTranslate();
//   const logout = useLogout();
//   return (
//     <MenuItemLink
//       ref={ref}
//       to=""
//       primaryText="Logout"
//       // leftIcon={<SettingsIcon />}
//       onClick={(e: any) => {
//         e.preventDefault();
//         logout();
//       }}
//       sidebarIsOpen
//     />
//   );
// });

// const CustomUserMenu = (props: any) => {
//   return (
//     <UserMenu {...props}>
//       <LogoutMenu />
//     </UserMenu>
//   );
// };

const TopAppBar = (props: any) => {
  // const logout = useLogout();
  const { identity, isLoading: identityLoading } = useGetIdentity();
  const [state, dispatch] = useContext(StoreContext);
  const api = useContext(APIContext);

  useEffect(() => {
    if (!identityLoading && identity?.id !== state.currentUser?.id) {
      loadData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [identityLoading]);

  const loadData = async () => {
    try {
      const user = await api.userService?.getUser(identity?.id as number);
      dispatch({ type: "SET_CURRENT_USER", payload: user });
    } catch (error: any) {
      console.log(error);
    }
  };

  return (
    <AppBar position="fixed" sx={classes.appBar}>
      <Toolbar sx={classes.toolbar}>
        <EventSelector />
        <EventTopCoordinates />
        {/* <RefreshDataButton /> */}
        {/* <CustomUserMenu /> */}
        <UserMenu />
      </Toolbar>
    </AppBar>
  );
};

export default TopAppBar;
